// Factual reference catalog for the cascading search filters.
// Data are real, publicly-known model families, generation codes + production
// years, and common variants — NOT fabricated listings/prices. Models without
// confident generation data use an empty `generations` array (the UI then only
// offers "All generations"). The structure is generic and extensible: add a
// brand/model/generation block to extend coverage — no code changes required.
//
// Each generation: { code, years (label), yearMin, yearMax(null = present), variants[] }

export const CATALOG = {
  BMW: {
    "1 Series": [
      { code: "E81/E82/E87/E88", years: "2004–2013", yearMin: 2004, yearMax: 2013, variants: ["116i", "118i", "120i", "116d", "118d", "120d"] },
      { code: "F20/F21", years: "2011–2019", yearMin: 2011, yearMax: 2019, variants: ["116i", "118i", "120i", "125i", "116d", "118d", "120d", "M135i", "M140i"] },
      { code: "F40", years: "2019–present", yearMin: 2019, yearMax: null, variants: ["118i", "116d", "118d", "120d", "M135i"] },
    ],
    "2 Series": [
      { code: "F22/F23", years: "2014–2021", yearMin: 2014, yearMax: 2021, variants: ["218i", "220i", "230i", "218d", "220d", "M240i"] },
      { code: "G42", years: "2021–present", yearMin: 2021, yearMax: null, variants: ["220i", "230i", "220d", "M240i"] },
    ],
    "3 Series": [
      { code: "E36", years: "1990–2000", yearMin: 1990, yearMax: 2000, variants: ["316i", "318i", "320i", "323i", "328i", "M3"] },
      { code: "E46", years: "1998–2006", yearMin: 1998, yearMax: 2006, variants: ["316i", "318i", "320i", "323i", "325i", "330i", "320d", "M3"] },
      { code: "E90/E91/E92/E93", years: "2005–2013", yearMin: 2005, yearMax: 2013, variants: ["318i", "320i", "325i", "330i", "335i", "318d", "320d", "330d", "M3"] },
      { code: "F30/F31/F34", years: "2012–2019", yearMin: 2012, yearMax: 2019, variants: ["316i", "318i", "320i", "330i", "340i", "316d", "318d", "320d", "330d", "330e"] },
      { code: "G20/G21", years: "2019–present", yearMin: 2019, yearMax: null, variants: ["318i", "320i", "330i", "320d", "330d", "330e", "M340i", "M340d"] },
    ],
    "4 Series": [
      { code: "F32/F33/F36", years: "2013–2020", yearMin: 2013, yearMax: 2020, variants: ["420i", "430i", "440i", "420d", "430d", "435d"] },
      { code: "G22/G23/G26", years: "2020–present", yearMin: 2020, yearMax: null, variants: ["420i", "430i", "420d", "M440i", "M440d"] },
    ],
    "5 Series": [
      { code: "E60/E61", years: "2003–2010", yearMin: 2003, yearMax: 2010, variants: ["520i", "523i", "525i", "530i", "520d", "525d", "530d", "M5"] },
      { code: "F10/F11", years: "2010–2017", yearMin: 2010, yearMax: 2017, variants: ["520i", "528i", "535i", "520d", "525d", "530d", "535d", "M5"] },
      { code: "G30/G31", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["520i", "530i", "540i", "520d", "530d", "530e", "M550i", "M5"] },
    ],
    "X1": [
      { code: "E84", years: "2009–2015", yearMin: 2009, yearMax: 2015, variants: ["sDrive18i", "sDrive18d", "xDrive20d", "xDrive25d"] },
      { code: "F48", years: "2015–2022", yearMin: 2015, yearMax: 2022, variants: ["sDrive18i", "sDrive20i", "sDrive18d", "xDrive20d", "xDrive25d"] },
      { code: "U11", years: "2022–present", yearMin: 2022, yearMax: null, variants: ["sDrive18i", "sDrive18d", "xDrive23i", "xDrive23d"] },
    ],
    "X3": [
      { code: "F25", years: "2010–2017", yearMin: 2010, yearMax: 2017, variants: ["xDrive20i", "xDrive28i", "xDrive20d", "xDrive30d"] },
      { code: "G01", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["xDrive20i", "xDrive30i", "xDrive20d", "xDrive30d", "M40i", "M40d"] },
    ],
    "X5": [
      { code: "E70", years: "2006–2013", yearMin: 2006, yearMax: 2013, variants: ["xDrive30i", "xDrive30d", "xDrive40d", "xDrive50i", "M"] },
      { code: "F15", years: "2013–2018", yearMin: 2013, yearMax: 2018, variants: ["xDrive30d", "xDrive40d", "xDrive50i", "M50d"] },
      { code: "G05", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["xDrive40i", "xDrive30d", "xDrive40d", "xDrive45e", "M50i", "M50d"] },
    ],
  },

  "Mercedes-Benz": {
    "A-Class": [
      { code: "W176", years: "2012–2018", yearMin: 2012, yearMax: 2018, variants: ["A160", "A180", "A200", "A180d", "A200d", "A250", "A45 AMG"] },
      { code: "W177", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["A180", "A200", "A180d", "A200d", "A220", "A250", "A35 AMG", "A45 AMG"] },
    ],
    "C-Class": [
      { code: "W204", years: "2007–2014", yearMin: 2007, yearMax: 2014, variants: ["C180", "C200", "C220 d", "C250", "C300", "C63 AMG"] },
      { code: "W205", years: "2014–2021", yearMin: 2014, yearMax: 2021, variants: ["C180", "C200", "C220 d", "C250 d", "C300", "C300 e", "C43 AMG", "C63 AMG"] },
      { code: "W206", years: "2021–present", yearMin: 2021, yearMax: null, variants: ["C180", "C200", "C220 d", "C300", "C300 e", "C43 AMG"] },
    ],
    "E-Class": [
      { code: "W212", years: "2009–2016", yearMin: 2009, yearMax: 2016, variants: ["E200", "E220 d", "E250", "E300", "E350", "E63 AMG"] },
      { code: "W213", years: "2016–2023", yearMin: 2016, yearMax: 2023, variants: ["E200", "E220 d", "E300", "E300 e", "E350", "E400 d", "E53 AMG", "E63 AMG"] },
    ],
    "GLC": [
      { code: "X253", years: "2015–2022", yearMin: 2015, yearMax: 2022, variants: ["GLC200", "GLC220 d", "GLC250", "GLC300", "GLC300 e", "GLC43 AMG"] },
      { code: "X254", years: "2022–present", yearMin: 2022, yearMax: null, variants: ["GLC200", "GLC220 d", "GLC300", "GLC300 e", "GLC43 AMG"] },
    ],
  },

  Audi: {
    A1: [
      { code: "8X", years: "2010–2018", yearMin: 2010, yearMax: 2018, variants: ["1.0 TFSI", "1.4 TFSI", "1.6 TDI", "S1"] },
      { code: "GB", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["25 TFSI", "30 TFSI", "35 TFSI", "40 TFSI"] },
    ],
    A3: [
      { code: "8P", years: "2003–2013", yearMin: 2003, yearMax: 2013, variants: ["1.6", "1.8 TFSI", "2.0 TFSI", "1.9 TDI", "2.0 TDI", "S3"] },
      { code: "8V", years: "2012–2020", yearMin: 2012, yearMax: 2020, variants: ["1.4 TFSI", "1.8 TFSI", "2.0 TFSI", "1.6 TDI", "2.0 TDI", "S3", "RS3"] },
      { code: "8Y", years: "2020–present", yearMin: 2020, yearMax: null, variants: ["30 TFSI", "35 TFSI", "40 TFSI", "30 TDI", "35 TDI", "S3", "RS3"] },
    ],
    A4: [
      { code: "B8", years: "2008–2015", yearMin: 2008, yearMax: 2015, variants: ["1.8 TFSI", "2.0 TFSI", "2.0 TDI", "3.0 TDI", "S4"] },
      { code: "B9", years: "2015–2023", yearMin: 2015, yearMax: 2023, variants: ["30 TDI", "35 TFSI", "35 TDI", "40 TFSI", "40 TDI", "45 TFSI", "S4"] },
    ],
    A6: [
      { code: "C7", years: "2011–2018", yearMin: 2011, yearMax: 2018, variants: ["2.0 TFSI", "2.0 TDI", "3.0 TDI", "3.0 TFSI", "S6"] },
      { code: "C8", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["40 TDI", "45 TFSI", "50 TDI", "55 TFSI", "S6"] },
    ],
    Q3: [
      { code: "8U", years: "2011–2018", yearMin: 2011, yearMax: 2018, variants: ["1.4 TFSI", "2.0 TFSI", "2.0 TDI", "RS Q3"] },
      { code: "F3", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["35 TFSI", "40 TFSI", "35 TDI", "40 TDI", "RS Q3"] },
    ],
    Q5: [
      { code: "8R", years: "2008–2017", yearMin: 2008, yearMax: 2017, variants: ["2.0 TFSI", "2.0 TDI", "3.0 TDI", "SQ5"] },
      { code: "FY", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["40 TDI", "45 TFSI", "50 TDI", "55 TFSI e", "SQ5"] },
    ],
  },

  Volkswagen: {
    Polo: [
      { code: "6R/6C", years: "2009–2017", yearMin: 2009, yearMax: 2017, variants: ["1.0", "1.2 TSI", "1.4 TDI", "GTI"] },
      { code: "AW", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["1.0", "1.0 TSI", "1.6 TDI", "GTI"] },
    ],
    Golf: [
      { code: "Mk5 (1K)", years: "2003–2009", yearMin: 2003, yearMax: 2009, variants: ["1.4 TSI", "1.6", "2.0 TDI", "GTI", "R32"] },
      { code: "Mk6 (5K)", years: "2008–2013", yearMin: 2008, yearMax: 2013, variants: ["1.2 TSI", "1.4 TSI", "1.6 TDI", "2.0 TDI", "GTI", "R"] },
      { code: "Mk7 (5G)", years: "2012–2020", yearMin: 2012, yearMax: 2020, variants: ["1.0 TSI", "1.4 TSI", "1.6 TDI", "2.0 TDI", "GTI", "GTD", "R", "e-Golf"] },
      { code: "Mk8 (CD)", years: "2019–present", yearMin: 2019, yearMax: null, variants: ["1.0 TSI", "1.5 TSI", "2.0 TDI", "GTI", "GTD", "R"] },
    ],
    Passat: [
      { code: "B7", years: "2010–2015", yearMin: 2010, yearMax: 2015, variants: ["1.4 TSI", "1.8 TSI", "1.6 TDI", "2.0 TDI"] },
      { code: "B8", years: "2014–2023", yearMin: 2014, yearMax: 2023, variants: ["1.4 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "GTE"] },
    ],
    Tiguan: [
      { code: "5N", years: "2007–2016", yearMin: 2007, yearMax: 2016, variants: ["1.4 TSI", "2.0 TSI", "2.0 TDI"] },
      { code: "AD", years: "2016–2023", yearMin: 2016, yearMax: 2023, variants: ["1.4 TSI", "1.5 TSI", "2.0 TSI", "2.0 TDI", "R"] },
    ],
  },

  Volvo: {
    S60: [
      { code: "P3", years: "2010–2018", yearMin: 2010, yearMax: 2018, variants: ["T3", "T4", "T5", "T6", "D2", "D3", "D4"] },
      { code: "P4", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["T4", "T5", "T6", "T8", "B4", "B5"] },
    ],
    V60: [
      { code: "P3", years: "2010–2018", yearMin: 2010, yearMax: 2018, variants: ["T3", "T4", "T5", "D2", "D3", "D4"] },
      { code: "P4", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["T5", "T6", "T8", "B4", "B5", "D3", "D4"] },
    ],
    XC60: [
      { code: "1st gen", years: "2008–2017", yearMin: 2008, yearMax: 2017, variants: ["T5", "T6", "D3", "D4", "D5"] },
      { code: "2nd gen", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["T5", "T6", "T8", "B4", "B5", "B6", "D4"] },
    ],
    XC90: [
      { code: "1st gen", years: "2002–2014", yearMin: 2002, yearMax: 2014, variants: ["2.5T", "T6", "D5"] },
      { code: "2nd gen", years: "2015–present", yearMin: 2015, yearMax: null, variants: ["T5", "T6", "T8", "B5", "B6", "D5"] },
    ],
  },

  Toyota: {
    Yaris: [],
    Corolla: [],
    "C-HR": [],
    RAV4: [],
  },

  Ford: {
    Fiesta: [],
    Focus: [],
    Kuga: [],
    Puma: [],
  },

  Peugeot: {
    208: [],
    308: [],
    2008: [],
    3008: [],
  },

  Renault: {
    Clio: [],
    Megane: [],
    Captur: [],
    Kadjar: [],
  },

  Skoda: {
    Fabia: [],
    Octavia: [],
    Superb: [],
    Kodiaq: [],
  },

  Opel: {
    Corsa: [],
    Astra: [],
    Insignia: [],
    Mokka: [],
  },

  MINI: {
    Hatch: [
      { code: "R56", years: "2006–2013", yearMin: 2006, yearMax: 2013, variants: ["One", "Cooper", "Cooper S", "Cooper D", "JCW"] },
      { code: "F56", years: "2014–present", yearMin: 2014, yearMax: null, variants: ["One", "Cooper", "Cooper S", "Cooper D", "Cooper SE", "JCW"] },
    ],
    Countryman: [
      { code: "R60", years: "2010–2016", yearMin: 2010, yearMax: 2016, variants: ["Cooper", "Cooper S", "Cooper D", "Cooper SD", "JCW"] },
      { code: "F60", years: "2017–2023", yearMin: 2017, yearMax: 2023, variants: ["Cooper", "Cooper S", "Cooper D", "Cooper SE", "JCW"] },
    ],
    Clubman: [],
  },

  Porsche: {
    911: [
      { code: "997", years: "2004–2012", yearMin: 2004, yearMax: 2012, variants: ["Carrera", "Carrera S", "Turbo", "GT3"] },
      { code: "991", years: "2011–2019", yearMin: 2011, yearMax: 2019, variants: ["Carrera", "Carrera S", "Turbo", "Turbo S", "GT3"] },
      { code: "992", years: "2019–present", yearMin: 2019, yearMax: null, variants: ["Carrera", "Carrera S", "Turbo", "Turbo S", "GT3"] },
    ],
    Cayenne: [
      { code: "92A", years: "2010–2017", yearMin: 2010, yearMax: 2017, variants: ["Cayenne", "S", "Diesel", "Turbo", "S E-Hybrid"] },
      { code: "9YA", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["Cayenne", "S", "Turbo", "E-Hybrid", "Turbo S E-Hybrid"] },
    ],
    Macan: [
      { code: "95B", years: "2014–present", yearMin: 2014, yearMax: null, variants: ["Macan", "S", "GTS", "Turbo"] },
    ],
    Panamera: [],
    Taycan: [],
  },

  SEAT: {
    Ibiza: [
      { code: "6J", years: "2008–2017", yearMin: 2008, yearMax: 2017, variants: ["1.2 TSI", "1.4 TSI", "1.6 TDI", "FR", "Cupra"] },
      { code: "KJ", years: "2017–present", yearMin: 2017, yearMax: null, variants: ["1.0 TSI", "1.5 TSI", "1.6 TDI", "FR"] },
    ],
    Leon: [
      { code: "5F", years: "2012–2020", yearMin: 2012, yearMax: 2020, variants: ["1.2 TSI", "1.4 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "FR", "Cupra"] },
      { code: "KL", years: "2020–present", yearMin: 2020, yearMax: null, variants: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "2.0 TDI", "e-Hybrid", "FR"] },
    ],
    Ateca: [],
    Arona: [],
  },

  Cupra: { Formentor: [], Leon: [], Born: [], Ateca: [], Tavascan: [] },

  "Alfa Romeo": { Giulia: [], Giulietta: [], Stelvio: [], Tonale: [], MiTo: [] },

  "Aston Martin": { DB11: [], Vantage: [], DBX: [], DB12: [] },

  Bentley: { "Continental GT": [], Bentayga: [], "Flying Spur": [] },

  Lamborghini: { "Huracán": [], Urus: [], Aventador: [] },

  McLaren: { "720S": [], "570S": [], GT: [], Artura: [] },

  "Rolls-Royce": { Ghost: [], Wraith: [], Cullinan: [], Phantom: [] },

  Abarth: { "595": [], "695": [], "500e": [] },

  Alpine: { A110: [] },

  BYD: { "Atto 3": [], Dolphin: [], Seal: [], "Tang": [] },

  Citroen: { C3: [], C4: [], "C5 Aircross": [], Berlingo: [], "C3 Aircross": [] },

  Dacia: { Sandero: [], Duster: [], Logan: [], Jogger: [], Spring: [] },

  DS: { "DS 3": [], "DS 4": [], "DS 7": [], "DS 9": [] },

  Fiat: { "500": [], Panda: [], Tipo: [], "500X": [], "500L": [] },

  Honda: { Civic: [], Jazz: [], "CR-V": [], "HR-V": [], "e:Ny1": [] },

  Hyundai: { i10: [], i20: [], i30: [], Tucson: [], Kona: [], "Santa Fe": [], Ioniq: [] },

  Jaguar: { XE: [], XF: [], "F-Pace": [], "E-Pace": [], "I-Pace": [] },

  Jeep: { Renegade: [], Compass: [], "Grand Cherokee": [], Wrangler: [], Avenger: [] },

  "Land Rover": { Defender: [], Discovery: [], "Discovery Sport": [], "Range Rover": [], "Range Rover Sport": [], "Range Rover Velar": [], "Range Rover Evoque": [] },

  Kia: {
    Picanto: [], Rio: [],
    Ceed: [
      { code: "ED", years: "2006–2012", yearMin: 2006, yearMax: 2012, variants: ["1.4", "1.6", "1.6 CRDi", "ProCeed", "cee'd SW"] },
      { code: "JD", years: "2012–2018", yearMin: 2012, yearMax: 2018, variants: ["1.4", "1.6 GDI", "1.6 CRDi", "GT", "SW"] },
      { code: "CD", years: "2018–present", yearMin: 2018, yearMax: null, variants: ["1.0 T-GDI", "1.4 T-GDI", "1.5 T-GDI", "1.6 CRDi", "GT", "SW", "ProCeed"] },
    ],
    Sportage: [
      { code: "SL", years: "2010–2015", yearMin: 2010, yearMax: 2015, variants: ["1.6 GDI", "1.7 CRDi", "2.0 CRDi"] },
      { code: "QL", years: "2015–2021", yearMin: 2015, yearMax: 2021, variants: ["1.6 GDI", "1.6 T-GDI", "1.7 CRDi", "2.0 CRDi", "GT Line"] },
      { code: "NQ5", years: "2021–present", yearMin: 2021, yearMax: null, variants: ["1.6 T-GDI", "1.6 HEV", "1.6 PHEV", "GT Line"] },
    ],
    Niro: [], "EV6": [], Sorento: [] },

  Lexus: { IS: [], ES: [], NX: [], RX: [], UX: [] },

  Mazda: { "2": [], "3": [], "6": [], "CX-3": [], "CX-5": [], "MX-5": [], "CX-30": [] },

  MG: { MG3: [], MG4: [], ZS: [], HS: [], MG5: [] },

  Mitsubishi: { "Space Star": [], ASX: [], Outlander: [], "Eclipse Cross": [] },

  Nissan: { Micra: [], Qashqai: [], Juke: [], Leaf: [], "X-Trail": [], Ariya: [] },

  Polestar: { "2": [], "3": [], "4": [] },

  Saab: { "9-3": [], "9-5": [] },

  smart: { fortwo: [], forfour: [], "#1": [], "#3": [] },

  Subaru: { Impreza: [], Forester: [], Outback: [], XV: [] },

  Suzuki: { Swift: [], Vitara: [], Ignis: [], "S-Cross": [], "Across": [] },

  Tesla: { "Model 3": [], "Model S": [], "Model X": [], "Model Y": [] },
};

export const catalogMakes = () => Object.keys(CATALOG).sort((a, b) => a.localeCompare(b));
export const modelsForMake = (make) => (make && CATALOG[make] ? Object.keys(CATALOG[make]) : []);
export const generationsFor = (make, model) => (make && model && CATALOG[make]?.[model]) || [];
export const variantsFor = (make, model, code) => {
  const gen = generationsFor(make, model).find((g) => g.code === code);
  return gen ? gen.variants || [] : [];
};
